import ReceivingBranchDetails from "./ReceivingBranchDetails";

function ReceivingBranchDetailsContainer(props : any) {
  const {detailsByIdItem, orderDetails, viewtype, detailsByIdIndex} = props

  return (
    <ReceivingBranchDetails 
    orderDetails = {orderDetails}
    detailsByIdItem = {detailsByIdItem}
    detailsByIdIndex = {detailsByIdIndex}
    viewtype={viewtype}
    />
  )
}

export default ReceivingBranchDetailsContainer